// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import VueMeta from 'vue-meta'
import store from './store'
import App from './App'
import router from './router'
import './assets/plugins/element'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/common.css'
import './assets/css/style.css'
import 'swiper/dist/css/swiper.css'
// import axios from './api/axios'
import axios from 'axios'

Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI)
Vue.use(Vuex)
Vue.use(VueMeta)
Vue.config.productionTip = false
Vue.prototype.$axios = axios

router.beforeEach((to, from, next) => {
  // console.log('11', to)
  if (to.meta.metaInfo) {
    // console.log('22')
    store.commit('CHANGE_META_INFO', to.meta.metaInfo)
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
  metaInfo () {
    return {
      title: this.$store.state.metaInfo.title,
      meta: [
        {
          name: 'keywords',
          content: this.$store.state.metaInfo.keywords
        }, {
          name: 'description',
          content: this.$store.state.metaInfo.description
        }
      ]
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js